import { useEffect } from 'react';
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { useDraftsAiSearchStore } from './useDraftsAiSearchStore';
const errorMessage = (t, errorCode)=>{
    switch(errorCode){
        case 'feature_disabled':
            return t.featureDisabled();
        case 'llm_timeout':
            return t.llmTimeout();
        case 'llm_error':
            return t.llmError();
        case 'llm_invalid_response':
            return t.llmInvalidResponse();
        case 'llm_schema_validation_failed':
            return t.llmSchemaValidationFailed();
        case 'search_failed':
            return t.searchFailed();
        case 'cannot_extract':
            return t.cannotExtract();
        case 'unknown':
            return t.unknown();
        default:
            return t.generic();
    }
};
export const useDraftsAiSearchErrorToast = (toastTestId)=>{
    const { showErrorToast } = useOverlayContext();
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch.errors');
    const errorCode = useDraftsAiSearchStore((s)=>s.errorCode);
    const setError = useDraftsAiSearchStore((s)=>s.setError);
    useEffect(()=>{
        if (errorCode == null) return;
        showErrorToast(errorMessage(t, errorCode), toastTestId);
        setError(null);
    }, [
        errorCode,
        showErrorToast,
        t,
        setError,
        toastTestId
    ]);
};
